import GenericComponent from '../GenericComponent';
import {addClickEvent} from '../helpers';

export default class trip_invite extends GenericComponent {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'trip_invite'), data);
    }

    get(forceUpdate, callback) {
        this.data.invite_sent = false;
        this.data.invite_token = null;
        this.data.invite_link = null;
        if (callback) callback();
        return this;
    }

    bindLinks() {
        super.bindLinks();

        addClickEvent(this.view, '[data-bind="btn-send-invite"]', event => {
            event.preventDefault();
            this.sendInvite();
        });

        addClickEvent(this.view, '[data-bind="btn-copy-link"]', event => {
            event.preventDefault();
            this.copyLink();
        });

        addClickEvent(this.view, '[data-bind="btn-share-link"]', event => {
            event.preventDefault();
            this.shareLink();
        });
    }

    sendInvite() {
        if (this._sending) return;
        const emailInput = this.view.querySelector('[name="invitee_email"]');
        const email = emailInput && emailInput.value.trim();
        if (!email || !emailInput.checkValidity()) {
            if (emailInput) emailInput.reportValidity();
            return;
        }

        this._sending = true;
        this.loading(true);
        this.app.ajax({
            url: `${this.app.settings.endpoints}trip/invite/`,
            method: 'POST',
            data: {
                data: {
                    checkin_id: this.data.checkin_id,
                    invitee_email: email
                }
            },
            callback: response => {
                this._sending = false;
                this.loading(false);
                this.data.invite_sent = true;
                this.data.invite_token = response.data.token;
                this.data.invite_link = this.buildInviteLink(response.data.token);
                this.render();
                if (this.parent && this.parent.loadInvitations) {
                    this.parent.loadInvitations();
                }
            },
            error: (status, data) => {
                this._sending = false;
                this.loading(false);
                this.submitOnError(null, status, data);
            }
        });
    }

    buildInviteLink(token) {
        const base = this.app.settings.endpoints.replace(/rest\/v2\/$/, '');
        return `${base}landing/trip/${token}`;
    }

    copyLink() {
        const linkEl = this.view.querySelector('[data-bind="invite-link-text"]');
        if (linkEl) {
            this.app.platform.share(linkEl.textContent.trim(), linkEl);
        }
    }

    shareLink() {
        const link = this.data.invite_link;
        if (!link) return;

        const shareText = this.inviteShareText || '';

        if (this.app.platform.shareNative) {
            this.app.platform.shareNative({
                title: '1Checkin',
                text: shareText,
                url: link
            });
        } else if (navigator.share) {
            navigator.share({text: shareText, url: link}).catch(() => {});
        } else {
            this.copyLink();
        }
    }
}
